import { render, staticRenderFns } from "./Close-Upload.vue?vue&type=template&id=4e0a8c21&scoped=true&"
import script from "./Close-Upload.vue?vue&type=script&lang=js&"
export * from "./Close-Upload.vue?vue&type=script&lang=js&"
import style0 from "./Close-Upload.vue?vue&type=style&index=0&id=4e0a8c21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a8c21",
  null
  
)

export default component.exports